import {informationUrl} from './informationLinks';
import {useEffect,useId,useRef,useState} from 'react';
import BrandLogo from './BrandLogo';
import './brandMenu.css';

export default function BrandMenu(){
  const [open,setOpen]=useState(false);
  const root=useRef<HTMLDivElement>(null);
  const trigger=useRef<HTMLButtonElement>(null);
  const linksId=useId();
  const close=()=>{setOpen(false);trigger.current?.focus({preventScroll:true});};

  useEffect(()=>{
    if(!open)return;
    const outside=(event:PointerEvent)=>{
      if(!(event.target instanceof Node)||root.current?.contains(event.target))return;
      // A following pointer default can focus the user's chosen destination.
      if(root.current?.contains(document.activeElement))trigger.current?.focus({preventScroll:true});
      setOpen(false);
    };
    const escape=(event:KeyboardEvent)=>{
      if(event.key!=='Escape')return;
      event.preventDefault();event.stopPropagation();
      setOpen(false);trigger.current?.focus({preventScroll:true});
    };
    document.addEventListener('pointerdown',outside,true);
    document.addEventListener('keydown',escape,true);
    return()=>{document.removeEventListener('pointerdown',outside,true);document.removeEventListener('keydown',escape,true);};
  },[open]);

  return <div ref={root} className="brand-menu" data-ui="brand-menu"
    onBlur={event=>{if(!event.currentTarget.contains(event.relatedTarget))setOpen(false);}}
    onPointerDown={event=>event.stopPropagation()} onPointerMove={event=>event.stopPropagation()}
    onPointerUp={event=>event.stopPropagation()} onPointerCancel={event=>event.stopPropagation()}
    onWheel={event=>event.stopPropagation()}>
    <button ref={trigger} type="button" className="brand brand-home brand-menu-trigger" aria-label="Graffiti information" aria-expanded={open} aria-controls={linksId} onClick={()=>setOpen(value=>!value)}>
      <BrandLogo decorative/>
      <small className="brand-tagline">One street. Everyone’s canvas.</small>
      <svg className="brand-menu-caret" viewBox="0 0 12 12" aria-hidden="true"><path d="m3 4.5 3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </button>
    <nav id={linksId} hidden={!open} className="brand-menu-links" aria-label="About Graffiti and policies">
      <a href={informationUrl('/about/')} target="_blank" rel="noopener noreferrer" onClick={close}>About<span aria-hidden="true">↗</span><span className="visually-hidden"> (opens in a new tab)</span></a>
      <a href={informationUrl('/how-to-play/')} target="_blank" rel="noopener noreferrer" onClick={close}>How to play<span aria-hidden="true">↗</span><span className="visually-hidden"> (opens in a new tab)</span></a>
      <a href={informationUrl('/terms/')} target="_blank" rel="noopener noreferrer" onClick={close}>Terms<span aria-hidden="true">↗</span><span className="visually-hidden"> (opens in a new tab)</span></a>
      <a href={informationUrl('/privacy/')} target="_blank" rel="noopener noreferrer" onClick={close}>Privacy<span aria-hidden="true">↗</span><span className="visually-hidden"> (opens in a new tab)</span></a>
    </nav>
  </div>;
}
